import { Navigate } from 'react-router-dom'

import { useNavigation } from 'modules/core/hooks/useNavigation'

const RedirectToProductUpdatesPage = () => {
  const { navigation } = useNavigation()
  const to = navigation.discover.productUpdates.fullPath()

  return <Navigate replace to={to} />
}

export default RedirectToProductUpdatesPage
